import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { Observable, from } from 'rxjs';

import { ButtonModule } from '@plugins/client/button/legacy-button';
import { ColorsModule } from '@plugins/client/colors/colors.module';
import { CancelIconComponent } from '@plugins/client/icons/cancel-icon';
import { ExclamationIconComponent } from '@plugins/client/icons/exclamation-icon';
import {
  LibTranslationModule,
  LibTranslationUtilsModule,
  TranslationsImport,
} from '@plugins/client/translation';

import { TRANSLATION_KEY } from '../translation-key';

@Component({
  selector: 'plugins-notice',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    CancelIconComponent,
    ExclamationIconComponent,
    LibTranslationUtilsModule,
    ColorsModule,
  ],
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoticeComponent extends LibTranslationModule {
  @Input() type: 'toast' | 'toast-float' | 'inlined' | 'actionable' = 'inlined';
  @Input() color!: string;
  @Input() dismissLabel?: string;

  @Output() dismiss = new EventEmitter<void>();

  @ContentChild('iconTemplate', { static: false })
  iconTemplateRef?: TemplateRef<unknown>;

  @ContentChild('actionTemplate', { static: false })
  actionTemplateRef?: TemplateRef<unknown>;

  constructor() {
    super(
      TRANSLATION_KEY,
      (lang: string) =>
        from(
          import(`../assets/i18n/${lang}.json`),
        ) as Observable<TranslationsImport>,
    );
  }
}
